/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatedAt
 */
export interface CreatedAt {
}

/**
 * Check if a given object implements the CreatedAt interface.
 */
export function instanceOfCreatedAt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreatedAtFromJSON(json: any): CreatedAt {
    return CreatedAtFromJSONTyped(json, false);
}

export function CreatedAtFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatedAt {
    return json;
}

export function CreatedAtToJSON(value?: CreatedAt | null): any {
    return value;
}

